import { getURLWithBasicParams } from '../components/request';
import { getCustomerId } from './offerData';
import {
  getCountryCode,
  getCurrency,
  getCurrencyRate,
  getLocale,
  getPage,
  getShop,
  getUTMData,
} from './pageData';

export const authenticatedFetch = async ({
  api,
  isRequestBodyPresent = false,
  requestBody = null,
  method = 'GET',
  token = null,
  useBasicParams = false,
}: {
  api: string;
  isRequestBodyPresent?: boolean;
  requestBody?: any;
  method?: string;
  token?: string | null;
  useBasicParams?: boolean;
}) => {
  const body = isRequestBodyPresent ? JSON.stringify(requestBody) : null;
  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  try {
    const res = await fetch(useBasicParams ? getURLWithBasicParams(api) : api, {
      method,
      headers,
      body,
    });

    if (res.ok) {
      const data = await res.json();
      return data;
    }
    throw new Error('Failed to fetch data');
  } catch (error) {
    console.error(error);
    return null;
  }
};

// Example POST method implementation:
export function postData(
  url = '',
  data: {
    shop_url?: string;
    page?: string;
    currency_code?: string;
    country_code?: string;
    conversion_rate?: string;
    utm?: any;
    locale?: string;
    customerId?: string;
    isPreview?: boolean;
  } = {},
) {
  data.shop_url = getShop();
  data.page = getPage();
  data.currency_code = getCurrency();
  data.country_code = getCountryCode();
  data.conversion_rate = getCurrencyRate();
  data.utm = getUTMData();
  data.locale = getLocale();
  data.customerId = getCustomerId();
  data.isPreview = false;

  // Default options are marked with *
  return fetch(url, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    // mode: 'cors', // no-cors, *cors, same-origin
    // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    // credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json',
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    // redirect: 'follow', // manual, *follow, error
    // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  }).then((response) => {
    return response.json();
  });

  // return response.json(); // parses JSON response into native JavaScript objects
}
